'use strict';

angular.module('mean.accounts-receivable').filter('toDate', function () {
    return function (items) {
        return new Date(items);
    };
});



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/filters/to-date.js